module.exports = __webpack_public_path__ + "familyspaceCode.png?ad2486fce9285499e70525a4cb6c8e02";